export default {
    workOrder_location_edit_title: "Edit Location",
    workOrder_location_create_title: "Create New Location",
    workOrder_location_no_changes_to_save: "No changes to save",
    workOrder_location_location_saved: "Location Saved",
    workOrder_location_nameIsAlreadyInUse: "The name is already in use",
    workOrder_location_name: "Name",
    workOrder_location_type: "Type",
    workOrder_location_address: "Address",
    workOrder_location_descripcion: "Description",
    workOrder_location_main: "Main",
    workOrder_location_regular: "Regular",
    workOrder_location_billing: "Billing",
    workOrder_location_addressFormatError: "The address is not valid"
};